import { useState } from "react";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";

const SUBMIT_URL = "https://readdy.ai/api/form/d6td1dlm9vk3c28i5gpg";

export default function ContactPage() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <main>
        <section className="py-20 bg-[#1a3a2e] text-center">
          <div className="max-w-4xl mx-auto px-4">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">Contact Us</span>
            <h1 className="text-5xl font-black text-white mb-4">Get Your Free Tree Service Estimate</h1>
            <p className="text-white/70 text-xl">Fill out the form or call us directly. We respond fast.</p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Form */}
            <div className="lg:col-span-2 bg-[#f8f6f3] rounded-2xl p-8 lg:p-10">
              <h2 className="text-3xl font-black text-[#1e1e1e] mb-2">Request a Free Estimate</h2>
              <p className="text-gray-500 text-sm mb-8">No obligation. We typically respond within 2 hours during business hours.</p>

              {status === "success" ? (
                <div className="flex flex-col items-center justify-center py-16 text-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-[#1a3a2e]/10 rounded-full mb-4">
                    <i className="ri-check-double-line text-4xl text-[#1a3a2e]"></i>
                  </div>
                  <h3 className="font-black text-[#1e1e1e] text-2xl mb-3">Message Received!</h3>
                  <p className="text-gray-500">We'll be in touch within 2 hours. For urgent needs, call us at (540) 776-4488.</p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Full Name *</label>
                      <input type="text" name="name" required placeholder="John Smith" className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Phone Number *</label>
                      <input type="tel" name="phone" required placeholder="(540) 000-0000" className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Email Address *</label>
                    <input type="email" name="email" required placeholder="your@email.com" className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Service Needed *</label>
                      <select name="service" required className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors cursor-pointer">
                        <option value="">Select service...</option>
                        <option>Tree Removal</option>
                        <option>Tree Trimming</option>
                        <option>Stump Grinding</option>
                        <option>Emergency Service</option>
                        <option>Multiple Services</option>
                        <option>Not Sure</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Your City / Zip *</label>
                      <input type="text" name="location" required placeholder="Fredericksburg, VA 22401" className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Preferred Date/Time</label>
                    <input type="text" name="preferred_date" placeholder="e.g. Next week, weekends preferred" className="w-full h-12 px-4 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-[#1e1e1e] uppercase tracking-wide mb-1.5">Describe Your Project</label>
                    <textarea name="message" rows={4} maxLength={500} placeholder="Tell us about the trees, their size, location, any concerns..." className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 text-sm bg-white focus:outline-none focus:border-[#e8632a] transition-colors resize-none"></textarea>
                  </div>

                  {status === "error" && (
                    <p className="text-red-500 text-sm">Something went wrong. Please call us at (540) 776-4488.</p>
                  )}

                  <button type="submit" disabled={loading} className="w-full h-14 bg-[#e8632a] text-white font-black text-lg rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer disabled:opacity-60 flex items-center justify-center gap-2 whitespace-nowrap">
                    {loading ? <><i className="ri-loader-4-line animate-spin"></i>Sending...</> : <><i className="ri-send-plane-fill"></i>Request Free Estimate</>}
                  </button>

                  <div className="flex flex-wrap items-center justify-center gap-4 pt-1">
                    {["100% Free", "No Obligation", "Fast Response", "Licensed & Insured"].map((t) => (
                      <span key={t} className="flex items-center gap-1 text-gray-400 text-xs">
                        <i className="ri-check-line text-[#1a3a2e]"></i>{t}
                      </span>
                    ))}
                  </div>
                </form>
              )}
            </div>

            {/* Contact sidebar */}
            <div>
              <h3 className="text-xl font-black text-[#1e1e1e] mb-6">Contact Information</h3>
              <div className="space-y-5 mb-8">
                <a href="tel:+15407764488" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#e8632a] rounded-xl flex-shrink-0">
                    <i className="ri-phone-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs uppercase tracking-wide">Call Us</p>
                    <p className="text-[#1e1e1e] font-black text-lg group-hover:text-[#e8632a] transition-colors">(540) 776-4488</p>
                  </div>
                </a>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1a3a2e]/10 rounded-xl flex-shrink-0">
                    <i className="ri-mail-fill text-[#1a3a2e] text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs uppercase tracking-wide">Email</p>
                    <a href="mailto:info@diversifiedtreeservices.com" className="text-[#1e1e1e] font-semibold text-sm hover:text-[#e8632a] transition-colors">info@diversifiedtreeservices.com</a>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1a3a2e]/10 rounded-xl flex-shrink-0">
                    <i className="ri-time-fill text-[#1a3a2e] text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs uppercase tracking-wide">Hours</p>
                    <p className="text-[#1e1e1e] font-semibold text-sm">Mon–Sat: 7am – 7pm</p>
                    <p className="text-gray-400 text-xs">Emergency: 24/7</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1a3a2e]/10 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-fill text-[#1a3a2e] text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs uppercase tracking-wide">Service Area</p>
                    <p className="text-[#1e1e1e] font-semibold text-sm">Northern Virginia</p>
                  </div>
                </div>
              </div>

              <div className="bg-[#e8632a]/10 border border-[#e8632a]/20 rounded-xl p-5">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-alarm-warning-fill text-[#e8632a] text-2xl"></i>
                  <p className="font-bold text-[#1e1e1e]">Emergency Service</p>
                </div>
                <p className="text-gray-600 text-sm mb-3">Storm damage or fallen trees? Call us immediately — we're available 24/7 for emergencies.</p>
                <a href="tel:+15407764488" className="flex items-center justify-center gap-2 w-full py-3 bg-[#e8632a] text-white font-bold rounded-lg text-sm cursor-pointer hover:bg-[#d0541e] transition-all whitespace-nowrap">
                  <i className="ri-phone-fill"></i>Call (540) 776-4488
                </a>
              </div>

              <div className="mt-6 rounded-xl overflow-hidden h-40">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d99376.1!2d-77.5982!3d38.3032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6c196de1e7d11%3A0x6a56c86d9c0a1b4d!2sFredericksburg%2C%20VA!5e0!3m2!1sen!2sus!4v1700000000002"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Service location map"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
